import React, { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useLanguage } from '@/hooks/useLanguage';

// Drop-in replacement for react-router's Link that keeps the /hi prefix while browsing in Hindi.
export const Link = forwardRef(function LocalizedLink({ to, ...props }, ref) {
  const { localize } = useLanguage();
  return <RouterLink ref={ref} to={localize(to)} {...props} />;
});
